export class PublicCompany {
    constructor({ User } = {}) {
        this.User = User;
        this.masterUsers = ["Super"];
    }

    /**
     * @param {object} args { roles: [], granted: [], isPublic: boolean }
     * @returns {boolean}
     * @description Verifica se o usuário tem permissão para modificar a empresa modelo.
     */
    hasPermissionToModify({ roles, granted, isPublic } = {}) {
        if (!isPublic) return true;
        granted = this.masterUsers.concat(granted);
        const hasPermission = this.User.checkPermission({ roles, granted });
        return hasPermission;
    }

    static hasPermissionModelToModify(companyId, user) {
        if (user.roles[0] == "Super") return true;
        if (companyId == "EMPRESA_MODELO") return false;
        return true;
    }
}
